import { memberLimitedLockColor } from '@assets/colors/brandColors';
import LockIcon from '@assets/images/common/icon/lock/LockIcon';
import Button from '@src/ui/elements/button/Button';

type Props = {
  registrationUrl: string;
  loginUrl: string;
};

export default function ArticleLoginPrompt({ registrationUrl, loginUrl }: Props) {
  return (
    <div className='flex flex-col items-center gap-4 rounded-md border border-[#e4e4e4] px-20 py-10 md:px-3 md:py-8'>
      <LockIcon
        fillColor={memberLimitedLockColor}
        width={30}
        height={30}
        role='img'
        aria-label='会員限定'
      />
      <p className='text-xl font-bold md:text-lg'>この記事は会員限定です</p>
      <p className='text-center text-xs'>
        <span className='md:mb-[3px] md:block'>会員登録（無料）すると、</span>
        <span>すべての会員限定記事をお読みいただけます。</span>
      </p>
      <div className='flex w-full gap-6 px-6 md:flex-col md:gap-4'>
        <Button
          size='m'
          fullRounded
          fullWidth
          href={registrationUrl}
          className='text-center'
        >
          新規会員登録
        </Button>
        <Button
          size='m'
          fullRounded
          fullWidth
          outline
          href={loginUrl}
          className='text-center'
        >
          ログイン
        </Button>
      </div>
      <p className='text-center text-xs'>既にアカウントをお持ちの方はログインしてください。</p>
    </div>
  );
}
